import { Component, OnInit } from '@angular/core';
import { eServiceCategory } from '../../../core/models/eServiceCategory';
import { LanguageService } from '../../../core/language/language.service';
import { EServicesService } from '../e-services.service';

@Component({
  selector: 'app-e-services-category',
  templateUrl: './e-services-category.component.html'
})
export class EServicesCategoryComponent implements OnInit {
  public languageID: number;
  public pathname: string;
  public showSearchBlock: boolean = false;

  public eServicesCategories: eServiceCategory[] = [];
  public administrationProcedures: any[] = [];
  public administrationProceduresFiltered: any[] = [];

  constructor(private _languageService: LanguageService,
    private _eServicesService: EServicesService) {
    this.languageID = this._languageService.selectedLanguageId;
  }

  ngOnInit() {
    this.pathname = location.pathname;    
    this.getAlleServices();
    this.getAlladministrationProcedures();
  }

  getAlleServices()  {
    this._eServicesService.getAlleServicesCategories(this.languageID).subscribe(result => {      
      this.eServicesCategories = result;      
    });
  }

  async focusOutSearch() {    
    await new Promise(f => setTimeout(f, 200));
    this.showSearchBlock = false;    
  }

  focusSearch() {
    this.showSearchBlock = true;  
  }

  getAlladministrationProcedures()  {
    this._eServicesService.getAdministrativeProcedureByName(this.languageID, '').subscribe(result => {      
      this.administrationProcedures = result;
      this.administrationProceduresFiltered = result;
    });    
  }

  onSearchChange(event: any): void {
    if(event.target.value.length > 2){
      this.administrationProceduresFiltered = this.administrationProcedures.filter(x => x.name.toLowerCase().includes(event.target.value.trim().toLowerCase()));
      this.showSearchBlock = true;      
    }
    else
    {
      this.showSearchBlock = false;
      this.administrationProceduresFiltered = [];
    }
  }
    downloadPDF() {
        const pdfUrl = "../../../assets/documents/instructions/admProc.pdf";
        const pdfName = 'korisnicke_upute_adm_proc.pdf';

        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = pdfName;
        link.click();
    }
}
